import { Injectable } from '@angular/core';

declare const fbq: any;

@Injectable({
  providedIn: 'root'
})
export class FacebookPixelServiceService {

  constructor() { }

  track(event: string, properties?: Object) {
    if (typeof fbq === 'undefined') {
      return;
    }
    fbq('track', event, properties);
  }
}
